import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { fetch } from "./fetch";

const updateBookingNotes = async (bookingId: string, notes: (string | undefined)[]) => {
  return fetch(`/api/bookings/${bookingId}/notes`, "PATCH", { notes });
};

export const useBookingNotesMutation = (bookingId: string) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { notes: (string | undefined)[]; toastId: any }) => updateBookingNotes(bookingId, data.notes),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Notes updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });

      navigate(`/bookings/${bookingId}?tab=overview`, { replace: true });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update booking notes!",
        variant: "destructive",
      });
    },
  });
};
